import { VideoStreamProviderService } from './../video-stream-provider.service';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-microframe',
  templateUrl: './microframe.component.html',
  styleUrls: ['./microframe.component.scss'],
})

export class MicroframeComponent implements OnInit {
  @Output() updateCameras = new EventEmitter<boolean>();

  private fb = inject(FormBuilder);
  private videoStreamProviderService = inject(VideoStreamProviderService)

  showAddMicroframeScoreboards = false;
  form: FormGroup;
  isSubmitting: boolean;
  token: string;

  constructor() { }

  ngOnInit() {
    this.buildForm();
  }


  buildForm() {
    this.form = this.fb.group({
        companyId: ['', [Validators.required]],
        password: ['', [Validators.required]],
        partner: ['microframes']
    });
  }

  saveToken() {
    this.videoStreamProviderService
      .updateCameras('microframe', this.token)
      .pipe(take(1))
      .subscribe({
        next: async res => {
          this.showAddMicroframeScoreboards = false;
          this.updateCameras.emit(true);
        }
      })
  }
}
